import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mascot from '@edx/brand/mascot.svg';

export default class PageLoading extends Component {
  renderSrMessage() {
    if (!this.props.srMessage) {
      return null;
    }

    return (
      <span className="sr-only">
        {this.props.srMessage}
      </span>
    );
  }

  render() {
    return (
      <div>
        <div
          className="d-flex justify-content-center align-items-center flex-column"
          style={{
            height: '100%',
            width: '100vw',
            backgroundColor: '#fff',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 100,
          }}
        >
          <div className="loader text-primary" role="status">
            <img src={mascot} alt="" />
            {this.renderSrMessage()}
          </div>
        </div>
      </div>
    );
  }
}

PageLoading.propTypes = {
  srMessage: PropTypes.string.isRequired,
};
